module.exports = __webpack_public_path__ + "assets/img/bg-01.420e40bc.png";